(function () {
  const COLLECTIONS = {};

  const COUNTS = {
    new: {
      'monthly-specials': 0,
      'most-popular': 0,
      'bw-copiers': 236,
      'color-copiers': 314,
      'copystar-new': 34,
      'konica-minolta-new': 84,
      'kyocera-new': 38,
      'muratec-new': 22,
      'ricoh-new': 83,
      'sharp-new': 92,
      'toshiba-new': 94,
      'xerox-new': 55,
      'speed-20-39': 214,
      'speed-40-59': 187,
      'speed-60-plus': 149
    },
    used: {
      'monthly-specials': 19,
      'most-popular': 18,
      'bw-copiers': 206,
      'color-copiers': 290,
      'copystar-used': 60,
      'konica-minolta-used': 77,
      'kyocera-used': 71,
      'muratec-used': 4,
      'ricoh-used': 81,
      'sharp-used': 86,
      'toshiba-used': 53,
      'xerox-used': 56,
      'speed-20-39': 199,
      'speed-40-59': 172,
      'speed-60-plus': 125
    }
  };

  const GROUPS = [
    { title: 'Current Deals', values: [['monthly-specials', 'Monthly Specials'], ['most-popular', 'Most Popular']] },
    { title: 'Color Capability', values: [['bw-copiers', 'Black & White'], ['color-copiers', 'Color']] },
    { title: 'Condition', type: 'condition' },
    {
      title: 'Brands',
      scoped: true,
      values: [
        ['copystar', 'Copystar'],
        ['konica-minolta', 'Konica Minolta'],
        ['kyocera', 'Kyocera'],
        ['muratec', 'Muratec'],
        ['ricoh', 'Ricoh'],
        ['sharp', 'Sharp'],
        ['toshiba', 'Toshiba'],
        ['xerox', 'Xerox']
      ]
    },
    { title: 'Print Speed (ppm)', values: [['speed-20-39', '20-39'], ['speed-40-59', '40-59'], ['speed-60-plus', '60+']] }
  ];

  function parts() {
    return window.location.pathname.split('/').filter(Boolean);
  }

  function context() {
    const pathParts = parts();
    const collectionIndex = pathParts.indexOf('collections');
    if (collectionIndex === -1) return null;
    const handle = pathParts[collectionIndex + 1];
    const config = COLLECTIONS[handle];
    if (!config) return null;
    const tagSegment = pathParts[collectionIndex + 2] || '';
    const activeTags = tagSegment ? tagSegment.split('+').filter(Boolean).map(decodeURIComponent) : [];
    return { handle, config, activeTags };
  }

  function paramsForFilter() {
    const current = new URLSearchParams(window.location.search);
    const params = new URLSearchParams();
    ['preview_theme_id', '_fd', 'pb', 'sort_by'].forEach((key) => {
      const value = current.get(key);
      if (value) params.set(key, value);
    });
    return params;
  }

  function paramsForClear() {
    const current = new URLSearchParams(window.location.search);
    const params = new URLSearchParams();
    ['preview_theme_id', '_fd', 'pb'].forEach((key) => {
      const value = current.get(key);
      if (value) params.set(key, value);
    });
    return params;
  }

  function url(handle, tags, params = paramsForFilter()) {
    const path = tags.length ? `/collections/${handle}/${tags.map(encodeURIComponent).join('+')}` : `/collections/${handle}`;
    const query = params.toString();
    return `${path}${query ? `?${query}` : ''}`;
  }

  function count(ctx, tag) {
    return COUNTS[ctx.config.condition]?.[tag] || 0;
  }

  function toggleUrl(ctx, tag) {
    const next = ctx.activeTags.includes(tag)
      ? ctx.activeTags.filter((value) => value !== tag)
      : ctx.activeTags.concat(tag);
    return url(ctx.handle, next);
  }

  function checkbox(active) {
    const box = document.createElement('span');
    box.className = active ? 'prestige-copier-filter-v2__box is-active' : 'prestige-copier-filter-v2__box';
    box.setAttribute('aria-hidden', 'true');
    return box;
  }

  function row(label, itemCount, active, href) {
    const link = document.createElement('a');
    link.className = active ? 'prestige-copier-filter-v2__link is-active' : 'prestige-copier-filter-v2__link';
    link.href = href;
    link.dataset.prestigeNavigate = 'true';
    link.setAttribute('role', 'checkbox');
    link.setAttribute('aria-checked', active ? 'true' : 'false');
    link.append(checkbox(active));

    const labelNode = document.createElement('span');
    labelNode.className = 'prestige-copier-filter-v2__label';
    labelNode.textContent = label;
    link.append(labelNode);

    const countNode = document.createElement('span');
    countNode.className = 'prestige-copier-filter-v2__count';
    countNode.textContent = String(itemCount);
    link.append(countNode);

    return link;
  }

  function group(title, children) {
    if (!children.length) return null;
    const section = document.createElement('section');
    section.className = 'prestige-copier-filter-v2__group';

    const heading = document.createElement('h3');
    heading.className = 'prestige-copier-filter-v2__heading';
    heading.textContent = title;
    section.appendChild(heading);

    const list = document.createElement('div');
    list.className = 'prestige-copier-filter-v2__list';
    children.forEach((child) => list.appendChild(child));
    section.appendChild(list);
    return section;
  }

  function conditionGroup(ctx) {
    return group('Condition', [
      row('New', COLLECTIONS['new-copiers'].count, ctx.handle === 'new-copiers', url('new-copiers', [], paramsForClear())),
      row('Pre-Owned', COLLECTIONS['used-copiers'].count, ctx.handle === 'used-copiers', url('used-copiers', [], paramsForClear()))
    ]);
  }

  function tagGroup(ctx, config) {
    const rows = config.values
      .map(([value, label]) => {
        const tag = config.scoped ? `${value}-${ctx.config.condition}` : value;
        return { tag, label, itemCount: count(ctx, tag) };
      })
      .filter((item) => item.itemCount > 0)
      .map((item) => row(item.label, item.itemCount, ctx.activeTags.includes(item.tag), toggleUrl(ctx, item.tag)));
    return group(config.title, rows);
  }

  function availabilityDetails(host) {
    return Array.from(host.querySelectorAll('.facet-accordion-details')).find((details) => {
      const summary = details.querySelector('summary, .accordion-details__summary');
      return summary && summary.textContent.trim().toLowerCase().includes('availability');
    });
  }

  function availabilityGroup(host, ctx) {
    const details = availabilityDetails(host);
    if (!details) return null;
    const activeAvailability = new URLSearchParams(window.location.search).get('filter.v.availability');
    const rows = [];

    details.querySelectorAll('input[type="checkbox"]').forEach((input) => {
      const label = input.closest('label, .facet-checkbox') || input.parentElement;
      if (!label) return;
      const countMatch = label.textContent.match(/(\d+)\s*$/);
      const itemCount = countMatch ? Number(countMatch[1]) : 0;
      const text = label.textContent.replace(/\d+\s*$/, '').replace(/\s+/g, ' ').trim();
      if (!text || itemCount === 0) return;
      const value = input.value || (text.toLowerCase().includes('out') ? '0' : '1');
      const params = paramsForFilter();
      if (activeAvailability === value) {
        params.delete('filter.v.availability');
      } else {
        params.set('filter.v.availability', value);
      }
      rows.push(row(text, itemCount, activeAvailability === value, url(ctx.handle, ctx.activeTags, params)));
    });

    details.classList.add('prestige-copier-filter-v2__native-hidden');
    return group('Availability', rows);
  }

  function panel(ctx, host) {
    const wrapper = document.createElement('div');
    wrapper.className = 'prestige-copier-filter-v2';

    const clear = document.createElement('a');
    clear.className = ctx.activeTags.length || new URLSearchParams(window.location.search).has('filter.v.availability')
      ? 'prestige-copier-filter-v2__clear'
      : 'prestige-copier-filter-v2__clear is-active';
    clear.href = url(ctx.handle, [], paramsForClear());
    clear.dataset.prestigeNavigate = 'true';
    clear.textContent = 'Clear Search';
    wrapper.appendChild(clear);

    GROUPS.forEach((filterGroup) => {
      const section = filterGroup.type === 'condition' ? conditionGroup(ctx) : tagGroup(ctx, filterGroup);
      if (section) wrapper.appendChild(section);
    });

    const availability = availabilityGroup(host, ctx);
    if (availability) wrapper.appendChild(availability);
    return wrapper;
  }

  function mount() {
    const ctx = context();
    if (!ctx) return;
    const host = document.getElementById('FacetFiltersContainer');
    if (!host) return;
    host.querySelector('.prestige-copier-filter-v2')?.remove();
    host.prepend(panel(ctx, host));
  }

  function forceNavigate(event) {
    const link = event.target.closest('[data-prestige-navigate="true"]');
    if (!link) return;
    const href = link.getAttribute('href');
    if (!href) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    window.location.href = new URL(href, window.location.origin).toString();
  }

  function scheduleMount() {
    window.clearTimeout(window.__prestigeCopierFilterV2Timer);
    window.__prestigeCopierFilterV2Timer = window.setTimeout(mount, 80);
  }

  document.addEventListener('click', forceNavigate, true);
  document.addEventListener('DOMContentLoaded', mount);
  document.addEventListener('shopify:section:load', scheduleMount);
  document.addEventListener('change', (event) => {
    if (event.target && event.target.closest('#SortByContainer, #SortByContainerMobile, form[is="facet-form"]')) {
      setTimeout(scheduleMount, 150);
      setTimeout(scheduleMount, 700);
    }
  });
  window.addEventListener('pageshow', scheduleMount);
  new MutationObserver(scheduleMount).observe(document.documentElement, { childList: true, subtree: true });
  setTimeout(scheduleMount, 250);
  setTimeout(scheduleMount, 1000);
})();
